import { useState, useEffect, useContext } from "react";
import { Grid, Stack, Box, GTIWebSelect, GTIWebDataGrid } from "@gti-controls-v2/web-core";
import useSearch from "../../../hooks/useSearch";
import { SettingsContext } from "../../../providers/settings";
import homePageStyles from "../../../common/styles/HomePage";
import DateRangeFilter from "../../../components/date-range-filter";

const Sessions = ({ TicketID, data, lookup }) => {
    const styles = homePageStyles;
    const dateFormat = "DD/MMM/YYYY";
    const today = new Date(new Date().toLocaleString("en-US", {timeZone: "PST"}));
    const lastYear = new Date(today);
    lastYear.setFullYear(today.getFullYear() - 1);

    const { handleLoading } = useContext(SettingsContext);
    const { getTicketSesiones } = useSearch();
    const [sesionesResult, setSesionesResult] = useState([]);
    const [deviceID, setDeviceID] = useState(0);
    const [dateTicket, setDateTicket] = useState({
        startDate: lastYear.toISOString().split('T')[0],
        endDate: today.toISOString().split('T')[0]
    });
    const [flag, setFlag] = useState(false);

    useEffect(() => {
        init();
        // eslint-disable-next-line
    }, [data, lookup]);

    const init = async () => {
        if (!flag) {
            setSesionesResult(data?.data);
            setFlag(true);
        }
    };

    useEffect(() => {
        cargarDatosGridSesiones();
        // eslint-disable-next-line
    }, [deviceID, dateTicket]);

    const cargarDatosGridSesiones = async () => {
        if (flag) {
            handleLoading(true);

            const resultado = await getTicketSesiones(TicketID, dateTicket.startDate, dateTicket.endDate, deviceID);
            setSesionesResult(resultado.data);
            
            handleLoading(false);
        }
    };

    const onChangeFiltroSesiones = (event) => {
        if (!flag) return;

        switch (event.target.name) {
            case "chkPlataformas":
                setDeviceID(event.target.value);
                break;
            case "dateRange":
                setDateTicket(event.target.value);
                break;
            default:
                break;
        }
    };

    const sesionesGridColumns = [
        { field: "SesEmpDeviceDesc", headerName: "Plataforma", width: "150" },
        { field: "SesEmpOSDesc", headerName: "Sistema Operativo", width: "250"  },
        { field: "EmpresaNombre", headerName: "Empresas", width: "400" },
        { field: "SesEmpInicial", headerName: "Fecha", width: "300" },
    ];

    return (
        <Grid>
            <Stack direction="row" spacing={3} sx={styles.sessionsContainer}>
                <Stack direction="column" sx={styles.sessionsLookup}>
                    <Box>
                        <GTIWebSelect
                            name="chkPlataformas"
                            dataSource={lookup?.data ?? []}
                            displayedValue="DeviceName"
                            selectedValue="DeviceId"
                            labelText="Plataforma"
                            value={deviceID}
                            disableDefaultReadOnly
                            onChange={onChangeFiltroSesiones}
                        />
                    </Box>
                </Stack>
                <Stack direction="column" sx={styles.sessionsDatePicker}>
                    <DateRangeFilter
                        name="fecha"
                        labelStart="Fecha inicial:"
                        labelEnd="Fecha final:"
                        labelTo="-"
                        dateFormat={dateFormat}
                        width="100%"
                        onChange={onChangeFiltroSesiones}
                        value={dateTicket}
                    />
                </Stack>
            </Stack>
            <Box>
                <br/>
                <Grid container>
                    <GTIWebDataGrid
                        pageSize={20}
                        rows={sesionesResult}
                        columns={sesionesGridColumns}
                        getRowId={(r) => r.SesEmpID}
                    />
                </Grid>
            </Box>
        </Grid>
    );
};

export default Sessions;
